export default {
    itemsCart: [],
    checkoutKey: 1,
    calledGetItemsCart: false,
    disabledVariation: false,
    listCartWithAdditionalProducts: []
}
